module.exports = __webpack_public_path__ + "band_14.7c3dd373.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/band_14.png
// module id = QCme
// module chunks = 0